import React from 'react';
import PropTypes from 'prop-types';

import styled from 'react-emotion';
import changeCase from 'change-case';

import { Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import InnerIcon from '~/modules/coreUI/components/basic/Icon';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import injectInBetween from '~/modules/core/utils/jsHelpers/injectElementBetweenChildElements';

const Icon = styled(InnerIcon)`
  color: ${props => props.theme.new.colors.labels.normal.subtle} !important;
  font-size: ${props => props.theme.new.fonts.sizes.xxl}px;
`;

const InlineSpacer = styled(Spacer)`
  display: inline-block;
`;

const PaymentMethods = props => (
  <Row fullWidth rightJustified>
    {injectInBetween(
      props.paymentMethods.map(method => (
        <div key={method.name}>
          <Icon className={`el-icon el-icon-${method.code}`} size="lg" title={method.description} />
          <InlineSpacer size={0.5} />
          <Label xs secondary>
            {changeCase.titleCase(method.name)}
          </Label>
        </div>
      )),
      <Separator vertical separatorLength="large" />,
      true,
    )}
  </Row>
);

PaymentMethods.propTypes = {
  paymentMethods: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default PaymentMethods;
